/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthLogoutResponse } from '../types/AuthLogout'

/**
 * POST /auth/logout
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::logout
 */
export async function authLogout(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthLogoutResponse>> {
	return axiosInstance.post('/auth/logout', undefined, config)
}
